import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react';
import { deleteCalculation } from '../api/calculation';

const DeleteCalculationModalComponent = ({
  isOpen,
  onClose,
  calculation,
  onSuccess,
}) => {
  const toast = useToast();

  const handleDelete = async () => {
    try {
      await deleteCalculation(calculation.id);
      toast({
        title: 'Success',
        description: 'Calculation deleted successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onSuccess();
      onClose();
    } catch (error) {
      const errorMessage =
        error.response?.data || 'An unexpected error occurred.';
      toast({
        title: 'Error',
        description: errorMessage,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (!calculation) {
    return null; // Eğer calculation undefined ise, modal'ı renderlama
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Calculation</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete the calculation "{calculation.name}
            "?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" ml={3} onClick={handleDelete}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteCalculationModalComponent;
